module.exports = __webpack_public_path__ + "static/media/RarityImage.2dc52566.png";